import { render, staticRenderFns } from "./PanelReferences.vue?vue&type=template&id=585e4dfa"
import script from "./PanelReferences.vue?vue&type=script&lang=js"
export * from "./PanelReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports